import "@fontsource-variable/figtree";
import "@fontsource-variable/inter";
import "@fontsource-variable/jetbrains-mono";
import "./index.css";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./app";
import { configureAuth } from "./lib/auth";
import { loadConfig } from "./lib/config";

const root = createRoot(document.getElementById("root")!);

loadConfig()
  .then((config) => {
    configureAuth(config);
    root.render(
      <StrictMode>
        <App />
      </StrictMode>,
    );
  })
  .catch((error: unknown) => {
    console.error(error);
    root.render(
      <main className="p-5 text-ink">
        <h1 className="heading text-2xl">Fusion Cloud is not available</h1>
        <p className="text-ink-muted">The console could not load its configuration. Reload the page in a moment.</p>
      </main>,
    );
  });
